import React from "react";

export const BoldIcon = () => (
    <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M15.4062 19.625H9.625V8.375H14.9375C15.5639 8.37504 16.1771 8.55435 16.7048 8.89174C17.2325 9.22914 17.6526 9.71052 17.9155 10.279C18.1784 10.8475 18.2731 11.4794 18.1884 12.1C18.1037 12.7206 17.8431 13.304 17.4375 13.7812C17.9673 14.205 18.3528 14.7825 18.5408 15.4344C18.7289 16.0862 18.7102 16.7803 18.4875 17.4211C18.2647 18.0619 17.8488 18.6179 17.297 19.0126C16.7452 19.4073 16.0847 19.6213 15.4062 19.625ZM11.5 17.75H15.3937C15.5784 17.75 15.7613 17.7136 15.9319 17.643C16.1025 17.5723 16.2575 17.4687 16.3881 17.3381C16.5187 17.2075 16.6223 17.0525 16.693 16.8819C16.7636 16.7113 16.8 16.5284 16.8 16.3438C16.8 16.1591 16.7636 15.9762 16.693 15.8056C16.6223 15.635 16.5187 15.48 16.3881 15.3494C16.2575 15.2188 16.1025 15.1152 15.9319 15.0445C15.7613 14.9739 15.5784 14.9375 15.3937 14.9375H11.5V17.75ZM11.5 13.0625H14.9375C15.1222 13.0625 15.305 13.0261 15.4756 12.9555C15.6463 12.8848 15.8013 12.7812 15.9319 12.6506C16.0625 12.52 16.166 12.365 16.2367 12.1944C16.3074 12.0238 16.3438 11.8409 16.3438 11.6562C16.3438 11.4716 16.3074 11.2887 16.2367 11.1181C16.166 10.9475 16.0625 10.7925 15.9319 10.6619C15.8013 10.5313 15.6463 10.4277 15.4756 10.357C15.305 10.2864 15.1222 10.25 14.9375 10.25H11.5V13.0625Z"
            fill="#212529"
        />
    </svg>
);

export const ItalicIcon = () => (
    <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M19.625 9.625V8.375H11.5V9.625H14.7125L11.9813 18.375H8.375V19.625H16.5V18.375H13.2875L16.0187 9.625H19.625Z"
            fill="#212529"
        />
    </svg>
);

export const StrikeIcon = () => (
    <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M21.5 13.375H15.2225C14.945 13.3004 14.6662 13.2306 14.3863 13.1656C12.6312 12.7506 11.6388 12.4469 11.6388 11.0262C11.6245 10.781 11.6608 10.5355 11.7454 10.3048C11.83 10.0742 11.9612 9.86345 12.1306 9.68562C12.6615 9.24906 13.3264 9.00851 14.0137 9.00437C15.7825 8.96062 16.5981 9.56063 17.265 10.4731L18.2744 9.73563C17.8019 9.0571 17.1578 8.51616 16.4078 8.16807C15.6578 7.81998 14.8288 7.67722 14.0056 7.75437C12.9944 7.76083 12.0189 8.12909 11.2556 8.7925C10.9663 9.08594 10.7402 9.43552 10.5913 9.8197C10.4423 10.2039 10.3736 10.6145 10.3894 11.0262C10.362 11.4768 10.4466 11.9271 10.6357 12.337C10.8248 12.7468 11.1125 13.1035 11.4731 13.375H6.5V14.625H15.0325C16.2619 14.9812 16.9969 15.445 17.0156 16.7237C17.0359 16.9969 16.9985 17.2713 16.9056 17.529C16.8128 17.7867 16.6667 18.0219 16.4769 18.2194C15.8155 18.7407 14.9938 19.0166 14.1519 19C13.5234 18.9818 12.9074 18.8209 12.3503 18.5295C11.7932 18.2382 11.3097 17.8239 10.9362 17.3181L9.97812 18.1206C10.4636 18.7676 11.0899 19.2955 11.8097 19.6645C12.5295 20.0334 13.3238 20.2336 14.1325 20.25H14.195C15.3492 20.2633 16.4695 19.8596 17.35 19.1131C17.6625 18.798 17.9054 18.4209 18.0632 18.0061C18.2209 17.5914 18.2898 17.1481 18.2656 16.705C18.289 15.947 18.0332 15.2069 17.5469 14.625H21.5V13.375Z"
            fill="#212529"
        />
    </svg>
);

export const UnorderedListIcon = () => (
    <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M8.375 11.5C9.41053 11.5 10.25 10.6605 10.25 9.625C10.25 8.58947 9.41053 7.75 8.375 7.75C7.33947 7.75 6.5 8.58947 6.5 9.625C6.5 10.6605 7.33947 11.5 8.375 11.5Z"
            fill="#212529"
        />
        <path
            d="M8.375 20.25C9.41053 20.25 10.25 19.4105 10.25 18.375C10.25 17.3395 9.41053 16.5 8.375 16.5C7.33947 16.5 6.5 17.3395 6.5 18.375C6.5 19.4105 7.33947 20.25 8.375 20.25Z"
            fill="#212529"
        />
        <path
            d="M14 17.75H22.75V19H14V17.75ZM14 9H22.75V10.25H14V9Z"
            fill="#212529"
        />
    </svg>
);

export const OrderedListIcon = () => (
    <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M14 17.75H22.75V19H14V17.75ZM14 9H22.75V10.25H14V9ZM9 11.5V6.5H7.75V7.125H6.5V8.375H7.75V11.5H6.5V12.75H10.25V11.5H9ZM10.25 21.5H6.5V19C6.5 18.6685 6.6317 18.3505 6.86612 18.1161C7.10054 17.8817 7.41848 17.75 7.75 17.75H9V16.5H6.5V15.25H9C9.33152 15.25 9.64946 15.3817 9.88388 15.6161C10.1183 15.8505 10.25 16.1685 10.25 16.5V17.75C10.25 18.0815 10.1183 18.3995 9.88388 18.6339C9.64946 18.8683 9.33152 19 9 19H7.75V20.25H10.25V21.5Z"
            fill="#212529"
        />
    </svg>
);

export const LinkIcon = () => (
    <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M22.2812 8.225C21.9328 7.8754 21.5189 7.59801 21.0631 7.40874C20.6072 7.21947 20.1185 7.12204 19.625 7.12204C19.1314 7.12204 18.6427 7.21947 18.1869 7.40874C17.7311 7.59801 17.3171 7.8754 16.9687 8.225L17.8562 9.1125C18.0889 8.87981 18.3652 8.69523 18.6692 8.56931C18.9732 8.44338 19.299 8.37856 19.6281 8.37856C19.9572 8.37856 20.283 8.44338 20.587 8.56931C20.8911 8.69523 21.1673 8.87981 21.4 9.1125C21.6327 9.34518 21.8172 9.62142 21.9432 9.92544C22.0691 10.2295 22.1339 10.5553 22.1339 10.8844C22.1339 11.2134 22.0691 11.5393 21.9432 11.8433C21.8172 12.1473 21.6327 12.4236 21.4 12.6562L16.4 17.6562C15.9309 18.1262 15.2943 18.3905 14.6303 18.3911C13.9663 18.3917 13.3293 18.1285 12.8594 17.6594C12.3894 17.1903 12.1251 16.5537 12.1245 15.8897C12.1239 15.2257 12.3871 14.5887 12.8562 14.1187L13.7375 13.2312L12.8562 12.3437L11.9687 13.2312C11.6191 13.5796 11.3417 13.9936 11.1525 14.4494C10.9632 14.9052 10.8658 15.3939 10.8658 15.8875C10.8658 16.381 10.9632 16.8697 11.1525 17.3256C11.3417 17.7814 11.6191 18.1954 11.9687 18.5437C12.6759 19.2419 13.6313 19.6308 14.625 19.625C15.1204 19.627 15.6114 19.5309 16.0694 19.3421C16.5275 19.1533 16.9436 18.8756 17.2937 18.525L22.2937 13.525C22.9943 12.8202 23.3865 11.8662 23.3842 10.8724C23.3818 9.87866 22.9851 8.92647 22.2812 8.225Z"
            fill="#212529"
        />
        <path
            d="M6.61873 19.5125C6.38535 19.2802 6.20016 19.0041 6.0738 18.7C5.94743 18.3959 5.88238 18.0699 5.88238 17.7406C5.88238 17.4113 5.94743 17.0853 6.0738 16.7812C6.20016 16.4772 6.38535 16.201 6.61873 15.9687L11.6187 10.9687C11.851 10.7354 12.1271 10.5502 12.4312 10.4238C12.7353 10.2974 13.0613 10.2324 13.3906 10.2324C13.7199 10.2324 14.0459 10.2974 14.35 10.4238C14.6541 10.5502 14.9302 10.7354 15.1625 10.9687C15.3944 11.2029 15.5769 11.4812 15.6993 11.7871C15.8217 12.0931 15.8814 12.4205 15.875 12.75C15.8769 13.0805 15.8132 13.4081 15.6877 13.7138C15.5622 14.0196 15.3773 14.2974 15.1437 14.5312L13.8187 15.875L14.7062 16.7625L16.0312 15.4375C16.7365 14.7322 17.1328 13.7756 17.1328 12.7781C17.1328 11.7807 16.7365 10.8241 16.0312 10.1187C15.3259 9.41344 14.3693 9.0172 13.3719 9.0172C12.3744 9.0172 11.4178 9.41344 10.7125 10.1187L5.71248 15.1187C5.36194 15.4672 5.08376 15.8816 4.89393 16.338C4.70411 16.7944 4.60638 17.2838 4.60638 17.7781C4.60638 18.2724 4.70411 18.7618 4.89393 19.2182C5.08376 19.6746 5.36194 20.089 5.71248 20.4375C6.42424 21.1303 7.38179 21.5124 8.37498 21.5C9.37692 21.501 10.3386 21.1055 11.05 20.4L10.1625 19.5125C9.93018 19.7459 9.65407 19.9311 9.35 20.0574C9.04593 20.1838 8.71989 20.2488 8.39061 20.2488C8.06132 20.2488 7.73528 20.1838 7.43121 20.0574C7.12714 19.9311 6.85103 19.7459 6.61873 19.5125Z"
            fill="#212529"
        />
    </svg>
);

export const CodeIcon = () => (
    <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M23.375 14L19 18.375L18.1188 17.4938L21.6063 14L18.1188 10.5062L19 9.625L23.375 14ZM4.625 14L9 9.625L9.88125 10.5062L6.39375 14L9.88125 17.4938L9 18.375L4.625 14ZM11.7625 19.9275L15.025 7.75L16.2325 8.07313L12.97 20.25L11.7625 19.9275Z"
            fill="#212529"
        />
    </svg>
);

export const TableIcon = () => (
    <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M13.5 7.5V11H8V12H13.5V15.5H7.5V9C7.5 8.17157 8.17157 7.5 9 7.5H13.5ZM14.5 12H20V11H14.5V7.5H19C19.8284 7.5 20.5 8.17157 20.5 9V15.5H14.5V12ZM7.5 16.5H13.5V20.5H9C8.17157 20.5 7.5 19.8284 7.5 19V16.5ZM14.5 16.5H20.5V19C20.5 19.8284 19.8284 20.5 19 20.5H14.5V16.5Z"
            stroke="#212529"
        />
    </svg>
);
